import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=78136f16&scoped=true&"
import script from "./PropertyList.vue?vue&type=script&lang=js&"
export * from "./PropertyList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=78136f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78136f16",
  null
  
)

export default component.exports